/*  eslint-disable */

import callMeNowAPI from '../api/CallMeNow';
import * as actionTypes from '../actions/actionTypes';
import SafeConsole from '../util/ConsoleUtils';

export function getCallMeNowSlots(vhtsegment, storeCode, requestTimeInCurrentTimezone = null) {
  return function(dispatch) {
    return callMeNowAPI.getCallMeNowSlots(vhtsegment, storeCode, requestTimeInCurrentTimezone, dispatch);
  };
}

export function createAppointmentInVHT(attempt, payload, requestTimeInCurrentTimezone, mainSuccessCallback = null) {
  return function(dispatch) {
    return callMeNowAPI
      .createAppointmentInVHT(payload, requestTimeInCurrentTimezone)
      .then((result) => {
        SafeConsole.info('createAppointmentInVHT attempt, result ', attempt, result);
        var vhtResponse = processVHTResult(result);
        vhtResponse['attempt'] = attempt;
        vhtResponse['appointmentTime'] = requestTimeInCurrentTimezone;
        if (vhtResponse.sendToVHTSuccess) {
          //complete other calls.
          postProcessingAfterVHTCall(payload, requestTimeInCurrentTimezone, mainSuccessCallback, vhtResponse);
        } else {
          if (mainSuccessCallback) {
            mainSuccessCallback(vhtResponse);
          }
        }
      })
      .catch((err) => {
        console.error('createAppointmentInVHT error:', err);
        var vhtResponse = { otherError: err, attempt: attempt, appointmentTime: requestTimeInCurrentTimezone };
        if (mainSuccessCallback) {
          mainSuccessCallback(vhtResponse);
        }
      });
  };
}

function postProcessingAfterVHTCall(payload, requestTimeInCurrentTimezone, mainSuccessCallback, vhtResponse) {
  //sendToV1 call
  callMeNowAPI
    .sendToV1(payload, requestTimeInCurrentTimezone)
    .then((v1Result) => {
      SafeConsole.info('sendToV1Response result', v1Result);
      vhtResponse['sendToV1Id'] = v1Result;
      vhtResponse['sendToV1Success'] = true;

      callMeNowAPI
        .sendToCSDB(payload, requestTimeInCurrentTimezone)
        .then((response) => {
          SafeConsole.info('sendToCSDB call returned:', response);
          vhtResponse['sendToCSDBSuccess'] = true;
          var sendIdPayload = {
            agent_json: {
              id: v1Result,
              vhtID: vhtResponse['interactionId'] ? vhtResponse['interactionId'] : 'FAILED',
            },
          };
          callMeNowAPI
            .sendId(sendIdPayload) //v1 put call
            .then((sendIdResponse) => {
              SafeConsole.info('sendId call returned:', sendIdResponse);
              vhtResponse['v1PutSuccess'] = true;
              if (mainSuccessCallback) {
                mainSuccessCallback(vhtResponse);
              }
            })
            .catch((err) => {
              console.error('sendId error:', err);
              vhtResponse['v1PutSuccess'] = false;
              if (mainSuccessCallback) {
                mainSuccessCallback(vhtResponse);
              }
            });
        })
        .catch((err) => {
          console.error('sendToCSDB error:', err);
          vhtResponse['sendToCSDBSuccess'] = false;
          if (mainSuccessCallback) {
            mainSuccessCallback(vhtResponse);
          }
        });
    })
    .catch((err) => {
      console.error('sendToV1 error:', err);
      vhtResponse['sendToV1Success'] = false;
      if (mainSuccessCallback) {
        mainSuccessCallback(vhtResponse, payload);
      }
    });
}

export function getAtlasId(callId, customerCallbackNumber) {
  return function(dispatch) {
    return callMeNowAPI
      .getAtlasId(callId, customerCallbackNumber)
      .then((result) => {
        SafeConsole.info('getAtlasId result', result);
        if (result) {
          var output = JSON.parse(result);
          SafeConsole.info('calling getAtlasId update callback function', output['universalId']);
          dispatch(atlasID(output['universalId']));
        }
      })
      .catch((err) => {
        console.error('getAtlasId error:', err);
      });
    // TODO: HANDLE HERE ERROR CASE
  };
}

export function cancelAppointment(vhtId, successCallback = null) {
  return function(dispatch) {
    return callMeNowAPI
      .cancelAppointment(vhtId)
      .then((result) => {
        SafeConsole.info('cancelAppointment result', result);
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(result, 'text/xml');
        var nodes = xmlDoc.getElementsByTagName('Code');
        var code = nodes && nodes.length > 0 ? nodes[0].childNodes[0].nodeValue : 'UNKNOWN';
        var cancellationStatus = 'Appointment Not Found';
        if (code === 107000) {
          cancellationStatus = 'Appointment Cancelled Successfully';
        }
        if (successCallback) {
          successCallback(cancellationStatus);
        }
      })
      .catch((err) => {
        console.error('cancelAppointment error:', err);
        if (successCallback) {
          successCallback('Failed to Cancel Appointment');
        }
      });
  };
}

function processVHTResult(result) {
  var response = { sendToVHTSuccess: false };
  var parser = new DOMParser();
  var xmlDoc = parser.parseFromString(result, 'text/xml');
  var nodes = xmlDoc.getElementsByTagName('Code');
  var code = nodes && nodes.length > 0 ? nodes[0].childNodes[0].nodeValue : 'UNKNOWN';
  var failureCodes = [107010, 107011, 107012, 107015, 108019, 108037];
  if (failureCodes.indexOf(Number(code)) > -1) {
    console.error('VHT Error code thrown', code);
    if (code === '108019') {
      //AppointmentTimeInThePast
      const interaction = xmlDoc.getElementsByTagName('Interaction');
      if (interaction.length > 0) {
        response['interactionId'] = interaction[0].getAttribute('Id');
      }
    }
    response['error'] = code;
  } else if (code === '107014') {
    response['error'] = code; //retry error
  } else if (code === '107000') {
    //success scenario
    const interaction = xmlDoc.getElementsByTagName('Interaction');
    if (interaction.length > 0) {
      response['interactionId'] = interaction[0].getAttribute('Id');
      response['sendToVHTSuccess'] = true;
    }
    SafeConsole.info('add interaction was successful');
  } else {
    response['error'] = code; //retry error
  }
  SafeConsole.info('processVHTResult response ', response);
  return response;
}

export const atlasID = (_atlasID) => {
  return {
    type: actionTypes.SET_ATLAS_ID,
    atlasID: _atlasID,
  };
};

export const setAtlasID = (_atlasID) => {
  return (dispatch) => {
    dispatch(atlasID(_atlasID));
  };
};

export const callMeNowResponse = (_callMeNowResponse) => {
  return {
    type: actionTypes.SET_CALL_ME_NOW_RESPONSE,
    callMeNowResponse: _callMeNowResponse,
  };
};

export const setCallMeNowResponse = (_callMeNowResponse) => {
  return (dispatch) => {
    dispatch(callMeNowResponse(_callMeNowResponse));
  };
};

export const createAppointmentResponse = (_createAppointmentResponse) => {
  return {
    type: actionTypes.SET_CREATE_APPT_RESPONSE,
    createAppointmentResponse: _createAppointmentResponse,
  };
};

export const setCreateAppointmentResponse = (_createAppointmentResponse) => {
  return (dispatch) => {
    dispatch(createAppointmentResponse(_createAppointmentResponse));
  };
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/actions/callMeNow.js